import { useEffect, useState } from 'react';
import type { RentalSelfServiceApiClient } from '#/services/rentalSelfServiceApiClient';
import { autorun } from 'mobx';
import { useAuthStore } from './useAuthStore';

export function useAuthenticatedSelfServiceApi(options: { required: true }): RentalSelfServiceApiClient;
export function useAuthenticatedSelfServiceApi(options?: { required?: false }): RentalSelfServiceApiClient | undefined;

export function useAuthenticatedSelfServiceApi({ required }: { required?: boolean } = {}) {
    const authStore = useAuthStore();
    const [selfServiceApiClient, setSelfServiceApiClient] = useState(() => authStore.selfServiceApiClient);
    useEffect(() => {
        authStore.renewIfExpired();
    }, [authStore]);
    useEffect(
        () =>
            autorun(() => {
                if (authStore.selfServiceApiClient) {
                    setSelfServiceApiClient(authStore.selfServiceApiClient);
                }
            }),
        [authStore.selfServiceApiClient]
    );
    if (required && !selfServiceApiClient) {
        throw new Error('SelfServiceApiClient is required but not available');
    }
    return selfServiceApiClient;
}
